/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the stage in which the given claim currently is. The higher the value, the closer to the end of the process it is.
 */
export const ClaimStatus = {
    InProgress: 1,
    OCRPending: 2,
    PendingApproval: 3,
    Approved: 4
} as const;
export type ClaimStatus = typeof ClaimStatus[keyof typeof ClaimStatus];

